export default __webpack_public_path__ + "static/media/EI4-1.c7864338.jpg";